<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Terence Connor was born in Whitechapel and has always lived in London, apart from attendance at universities and periods working abroad in Spain (film extra English classes in a language school, and private tutor to a bullfighter) and in Ecuador (volunteer in a shanty town). He has studied at the universities of Newcastle-upon-Tyne, Kent and LSE, worked in social services departments and in a voluntary child care and adoption agency. More recently, he has obtained a masters in creative writing with distinction from Exeter University. This is his first novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?14b67574